module.exports = __webpack_public_path__ + "public/img/bannar-chengguo-phone.801d4cb7.png";